module.exports = "<div class=\"c-full-height-layout-box\">\n    <h2 class=\"c-full-height-layout-box__heading c-heading\">Te hemos enviado un email</h2>\n        <div class=\"h-mt15\">\n            <p>\n                Recibirás un email con un link para introducir una nueva contraseña.\n            </p>\n        </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/login/templates/partials/email-sent.html
// module id = ./src/app/modules/login/templates/partials/email-sent.html
// module chunks = main